import { FormattedMessage } from '@utils/i18n';

const LotRowHeader = () => {
    return (
        <ul className="Body-XS semibold flex w-full px-4 pt-2">
            <li className="w-full text-start">
                <FormattedMessage id="invest_act_shares_number" />
            </li>
            <li className="w-full text-center">
                <FormattedMessage id="invest_act_buy_price" />
            </li>
            <li className="w-full text-end lg:text-right">
                <FormattedMessage id="invest_act_gain_loss" />
            </li>
        </ul>
    );
};

export default LotRowHeader;
